<template>
<svg :style="style">
  <use :xlink:href="require('@/assets/images/sprite.svg') + '#' + icon"></use>
</svg>
</template>

<script>
export default {
  name: "BaseIcon",
  props: {
    icon: {
      type: String,
      required: true,
    },
    height: {
      type: Number,
      required: false,
      default: 3,
    },
    width: {
      type: Number,
      required: false,
      default: 3,
    }
  },
  computed: {
    style() {
      return "width: "+this.width+"rem; height: "+this.height+"rem;";
    }
  }
}
</script>

<style scoped>
</style>